import { put } from "redux-saga/effects";
import {
  ADD_NEW_TRANSACTION,
  FETCH_BUDGET,
  UPDATE_BUDGET,
  DELETE_BUDGET,
  GRAPH_DATA_PERIOD,
  TOTAL_BUDGET_SUMMARIZE,
  CURRENCY_UPDATE,
} from "../../../api"; // api

import {
  fetchBudgetListSuccessful,
  fetchBudgetListFailure,
  addNewBudgetTransactionSuccessful,
  addNewBudgetTransactionFailure,
  updateTheBudgetTransactionSuccessful,
  updateTheBudgetTransactionFailure,
  deleteTheBudgetTransactionSuccessful,
  deleteTheBudgetTransactionFailure,
  getGraphDataOfSelectedPeriodSuccessful,
  getGraphDataOfSelectedPeriodFailure,
  getTotalBudgetSummarizeSuccessful,
  getTotalBudgetSummarizeFailure, updateCurrencySuccessful, updateCurrencyFailure,
} from "../../actions/budget"; // action
import { setLoading } from "../../actions/loading"; // action
import axios from "axios";
import Swal from "sweetalert2";

export function* addNewBudgetTransaction(body) {
  try {
    yield put(setLoading(true))
    yield axios.post(
      ADD_NEW_TRANSACTION,
      { ...body.payload },
      { withCredentials: true }
    );
    yield fetchBudgetList({ limit: 10 });
    yield put(addNewBudgetTransactionSuccessful());
    yield put(setLoading(false))

  } catch (error) {
    yield put(addNewBudgetTransactionFailure());
    yield put(setLoading(false))

  }
}

export function* fetchBudgetList(payload) {
  try {
    yield put(setLoading(true))
    const filter = payload?.payload || payload;
    const  {data}  = yield axios.put(FETCH_BUDGET, filter, {
      withCredentials: true,
    });
    let budgetList = data.data === null ? [] :  data.result;
    const locale = JSON.parse(localStorage.getItem("userInfo")).userInfo.locale;
    let currency =  data.currency;
    yield put(fetchBudgetListSuccessful({ budgetList: budgetList, currency, locale }));
    yield put(setLoading(false))

  } catch (error) {
    yield put(fetchBudgetListFailure());
    yield put(setLoading(false))
  }
}

export function* updateTheBudgetTransaction(updateData) {
  try {
    yield put(setLoading(true))
    const payload = yield axios.put(UPDATE_BUDGET, updateData.payload, {
      withCredentials: true,
    });
    console.log("update payload", payload);
    if (payload.status === 200 && payload.data === "Günceleme Başarılı") {
      yield fetchBudgetList({ limit: 10 });
    }
    yield put(updateTheBudgetTransactionSuccessful(payload.data));
    yield put(setLoading(false))

  } catch (error) {
    console.log("güncelleme olurken hata oluştu", error);
    yield put(updateTheBudgetTransactionFailure());
    yield put(setLoading(false))
  }
}

export function* deleteTheBudgetTransaction(deleteBudget) {
  try {
    yield put(setLoading(true))
    const payload = yield axios.post(DELETE_BUDGET, deleteBudget.payload, {
      withCredentials: true,
    });
    if (payload.status === 200 && payload.data === "Silme işlemi Başarılı") {
      yield fetchBudgetList({ limit: 10 });
    }
    yield put(deleteTheBudgetTransactionSuccessful(payload.data));
    yield put(setLoading(false))
  } catch (error) {
    console.log("silme işlemi yapılırken hata oluştu", error);
    yield put(deleteTheBudgetTransactionFailure());
    yield put(setLoading(false))
  }
}

export function* getGraphDataOfSelectedPeriod({ payload }) {
  try {
    yield put(setLoading(true))
    const data = yield axios.put(GRAPH_DATA_PERIOD, payload, {
      withCredentials: true,
    });
    yield put(getGraphDataOfSelectedPeriodSuccessful(data.data));
    yield put(setLoading(false))
  } catch (error) {
    console.log("Grafik datası alınırken bir hata oluştu", error);
    // yield failure
    yield put(setLoading(false))

  }
}

export function* getTotalBudgetSummarize() {
  try {
    yield put(setLoading(true))
    const payload = yield axios.get(TOTAL_BUDGET_SUMMARIZE, {
      withCredentials: true,
    });
    yield put(getTotalBudgetSummarizeSuccessful(payload.data));
    yield put(setLoading(false))
  } catch (error) {
    console.log("getTotalBudgetSummarize  hata oluştu", error);
    yield put(getTotalBudgetSummarizeFailure());
    yield put(setLoading(false))
  }
}

export function* updateCurrency(currency) {
  try {
    yield put(setLoading(true))
    const payload = yield axios.put(CURRENCY_UPDATE, {
      currency: currency.payload
    }, {
      withCredentials: true,
    });
    if (payload.status === 200 && payload.data === "Günceleme Başarılı") {
          Swal.fire({
            icon: 'success',
            text: 'Para birimi güncellendi',
          })
      yield put(updateCurrencySuccessful(payload.data));
      yield put(setLoading(false))
    }else{
      Swal.fire({
        icon: 'error',
        text: 'Para birimi güncellenemedi',
      })
    }
  } catch (error) {
    console.log("Güncelleme olurken hata oluştu", error);
    yield put(updateCurrencyFailure());
    yield put(setLoading(false))
  }
}
